import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
  flex-direction: column;
  padding: ${props => props.theme.spacing.sp16};
  border: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.subtle};
  border-radius: ${props => props.theme.primitives.radius.radius4};
`

export const Header = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp12};
  flex: 1;
  min-width: 0;
`

export const TextLines = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp4};
  width: 100%;
`

export const CodeBlocks = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
`
